import { useEffect } from 'react';
import { fetchStoredLvPdf } from '../utils/fetchStoredLvPdf';

/**
 * When navigating to an order page with a saved property that has lv_pdf_storage_path
 * (and no inline pdfBase64), fetch PDF bytes from the API.
 */
export function useStoredLvPdfHydration(initialProperty, getToken, {
  setPdfBase64,
  setPdfName,
  setXml,
  setSummary,
  setError,
  setLoadLoading,
  translateError,
  allowTargetUserId = false,
}) {
  const path = initialProperty?.lv_pdf_storage_path || initialProperty?.lvPdfStoragePath;
  const k = initialProperty?.kod_ku != null ? String(initialProperty.kod_ku).trim() : '';
  const l = initialProperty?.cislo_lv != null ? String(initialProperty.cislo_lv).trim() : '';
  const uid = initialProperty?.user_id != null ? String(initialProperty.user_id).trim() : '';
  const hasInlinePdf = !!(initialProperty?.pdfBase64 && String(initialProperty.pdfBase64).trim());

  useEffect(() => {
    if (!initialProperty || !path || hasInlinePdf || !k || !l) {
      return undefined;
    }

    let cancelled = false;
    if (setLoadLoading) setLoadLoading(true);
    if (setError) setError(null);

    (async () => {
      try {
        const { pdfBase64, pdfName } = await fetchStoredLvPdf(getToken, {
          kod_ku: k,
          cislo_lv: l,
          user_id: allowTargetUserId ? (uid || undefined) : undefined,
        });
        if (cancelled) return;
        setPdfBase64(pdfBase64);
        setPdfName(pdfName || 'LV.pdf');
        if (setXml) setXml(null);
        if (setSummary) setSummary(null);
      } catch (e) {
        if (!cancelled && setError) {
          setError(e.message || (translateError ? translateError() : 'Failed to load stored PDF.'));
        }
      } finally {
        if (!cancelled && setLoadLoading) setLoadLoading(false);
      }
    })();

    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps -- use path/k/l/uid instead of initialProperty reference
  }, [
    path,
    k,
    l,
    uid,
    hasInlinePdf,
    getToken,
    setPdfBase64,
    setPdfName,
    setXml,
    setSummary,
    setError,
    setLoadLoading,
    allowTargetUserId,
  ]);
}
